import type { RouteRecordRaw } from 'vue-router';

export const reportsRoutes: RouteRecordRaw = {
    path: 'reports',
    components: {
        default: () => import('@/layouts/modules/reports/ReportsLayout.vue'),
        sidebar: () => import('@/layouts/modules/reports/ReportAside.vue')
    },
    props: true,
    children: [
        {
            path: '',
            name: 'reports',
            component: () => import('@/views/modules/reports/SystemReportsView.vue'),
        },
        {
            path: ':reportId/formats',
            name: 'reportFormats',
            component: () => import('@/views/modules/reports/SystemReportFormatsView.vue'),
            props: true,
        },
        {
            path: ':reportID/school-connected',
            name: 'schoolConnectedReports',
            component: () => import('@/views/modules/reports/school/SchoolConnectedReportsView.vue'),
            props: true,
            beforeEnter: (to, _from, next) => {
                // Ensure proper initial navigation
                if (to.name === 'schoolConnectedReports') {
                    next({
                        name: 'schoolConnectedReportDetails',
                        params: { reportID: to.params.reportID }
                    });
                } else {
                    next();
                }
            },
            children: [
                {
                    path: '',
                    name: 'schoolConnectedReportsIndex',
                    redirect: to => ({
                        name: 'schoolConnectedReportDetails',
                        params: { reportID: to.params.reportID }
                    })
                },
                {
                    path: 'details',
                    name: 'schoolConnectedReportDetails',
                    component: () => import('@/views/modules/reports/school/SchoolConnectedReportDetailsView.vue'),
                    props: true,
                },
                {
                    path: 'formats',
                    name: 'schoolConnectedReportFormats',
                    component: () => import('@/views/modules/reports/school/SchoolConnectedReportFormats.vue'),
                    props: true,
                },
                {
                    path: 'settings',
                    name: 'schoolConnectedReportSettings',
                    component: () => import('@/views/modules/reports/school/SchoolConnectedReportSettingsView.vue'),
                    props: true,
                    children: [
                        {
                            path: ':settingId/configurations',
                            name: 'schoolConnectedReportSettingsConfigurations',
                            component: () => import('@/views/modules/reports/school/SchoolConnectedReportSettingConfigurationsView.vue'),
                            props: true
                        }
                    ],
                }
            ]
        }
    ],
};